import script from "./ReviewsOnProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./ReviewsOnProduct.vue?vue&type=script&setup=true&lang=js"

import "./ReviewsOnProduct.vue?vue&type=style&index=0&id=653b49af&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-653b49af"]])

export default __exports__